<template>
<body>
  
  <div>
    <div class="container2">
      <div class="question">Funktions- und abteilungsübergreifendes Lernen wird in der Organisation gefordert und gefördert.</div>
      <div class="slider"><input type="range" class="mySlider" min="1" max="5" :value="kultur" @input="update" />
      <span :style="warning()" class="rangeValue"> {{kultur}} </span></div>
    </div>

    <div class="container2">
      <div class="question">Die Organisation reagiert typischerweise gut auf Konkurrenten und andere Veränderungen im externen Geschäftsumfeld.</div>
      <div class="slider"><input type="range" class="mySlider" min="1" max="5" :value="kultur2" @input="update2" />
      <span :style="warning2()" class="rangeValue"> {{kultur2}} </span></div>
    </div>

    <div class="container2">
      <div class="question">In dieser Organisation zu arbeiten ist wie ein Teil eines Teams zu sein.</div>
      <div class="slider"><input type="range" class="mySlider" min="1" max="5" :value="kultur3" @input="update3" />
      <span :style="warning3()" class="rangeValue"> {{kultur3}} </span></div>
    </div>

    <div class="container2">
      <div class="question">Diese Organisation delegiert ausreichend Verantwortung, so dass die Mitarbeiter selbständig handeln können.</div>
      <div class="slider"><input type="range" class="mySlider" min="1" max="5" :value="kultur4" @input="update4" />
      <span :style="warning4()" class="rangeValue"> {{kultur4}} </span></div>
    </div>

    <div class="container2">
      <div class="question">In der Organisation gibt eine gemeinsame Vision davon, wie die Organisation in Zukunft aussehen soll.</div>
      <div class="slider"><input type="range" class="mySlider" min="1" max="5" :value="kultur5" @input="update5" />
      <span :style="warning5()" class="rangeValue"> {{kultur5}} </span></div>
    </div>

    <div class="container2">
      <div class="question">Menschen aus unterschiedlichen Organisationseinheiten haben dennoch eine gemeinsame Perspektive die sie vereint.</div>
      <div class="slider"><input type="range" class="mySlider" min="1" max="5" :value="kultur6" @input="update6" />
      <span :style="warning6()" class="rangeValue"> {{kultur6}} </span></div>
    </div>

    <div class="container2">
      <div class="question">Strategische Veränderungen werden in der Regel von den Mitarbeitern schnell akzeptiert.</div>
      <div class="slider"><input type="range" class="mySlider" min="1" max="5" :value="kultur7" @input="update7" />
      <span :style="warning7()" class="rangeValue"> {{kultur7}} </span></div>
    </div>


    <div class="container3">
      <button class="button_save" @click="evaluateForm">auswerten</button>
    </div>


  </div>

    
  </body>
</template>

<script>
  export default {
    props: ["KulturValue", "KulturValue2", "KulturValue3", "KulturValue4", "KulturValue5", "KulturValue6", "KulturValue7", "KulturValue8", "KulturValue9", "KulturValue10"],
    data(){
      return {
        kultur: this.KulturValue,
        kultur2: this.KulturValue2,
        kultur3: this.KulturValue3,
        kultur4: this.KulturValue4,
        kultur5: this.KulturValue5,
        kultur6: this.KulturValue6,
        kultur7: this.KulturValue7,
        kultur8: this.KulturValue8,
        kultur9: this.KulturValue9,
        kultur10: this.KulturValue10,
      }
    },
    methods: {   
      update(a){
        this.kultur = a.target.value
      },
      update2(b){
        this.kultur2 = b.target.value
      },
      update3(c){
        this.kultur3 = c.target.value
      },
      update4(d){
        this.kultur4 = d.target.value
      },
      update5(e){
        this.kultur5 = e.target.value
      },
      update6(f){
        this.kultur6 = f.target.value
      },
      update7(g){
        this.kultur7 = g.target.value
      },
      update8(h){
        this.kultur8 = h.target.value
      },
      update9(i){
        this.kultur9 = i.target.value
      },
      update10(j){
        this.kultur10 = j.target.value
      },

      warning:function(){
        if(this.kultur == 5){
          return{
            color: "#62aa6c",
            animation: "anim .3s ease-in 1 alternate"
          }
        }
        if (this.kultur == 4)
          return{
            color: "#A1A250",
          }
        if (this.kultur == 3)
          return{
            color: "#E09A34",
          }
        if (this.kultur == 2)
          return{
            color: "#E87735",
          }
        if (this.kultur == 1)
          return{
            color: "#F44336",
          }

      },
      warning2:function(){
        if(this.kultur2 == 5){
          return{
            color: "#62aa6c",
            animation: "anim .3s ease-in 1 alternate"
          }
        }
        if (this.kultur2 == 4)
          return{
            color: "#A1A250",
          }
        if (this.kultur2 == 3)
          return{
            color: "#E09A34",
          }
        if (this.kultur2 == 2)
          return{
            color: "#E87735",
          }
        if (this.kultur2 == 1)
          return{
            color: "#F44336",
          }

      },
      warning3:function(){
        if(this.kultur3 == 5){
          return{
            color: "#62aa6c",
            animation: "anim .3s ease-in 1 alternate"
          }
        }
        if (this.kultur3 == 4)
          return{
            color: "#A1A250",
          }
        if (this.kultur3 == 3)
          return{
            color: "#E09A34",
          }
        if (this.kultur3 == 2)
          return{
            color: "#E87735",
          }
        if (this.kultur3 == 1)
          return{
            color: "#F44336",
          }

      },
      warning4:function(){
        if(this.kultur4 == 5){
          return{
            color: "#62aa6c",
            animation: "anim .3s ease-in 1 alternate"
          }
        }
        if (this.kultur4 == 4)
          return{
            color: "#A1A250",
          }
        if (this.kultur4 == 3)
          return{
            color: "#E09A34",
          }
        if (this.kultur4 == 2)
          return{
            color: "#E87735",
          }
        if (this.kultur4 == 1)
          return{
            color: "#F44336",
          }

      },
      warning5:function(){
        if(this.kultur5 == 5){
          return{
            color: "#62aa6c",
            animation: "anim .3s ease-in 1 alternate"
          }
        }
        if (this.kultur5 == 4)
          return{
            color: "#A1A250",
          }
        if (this.kultur5 == 3)
          return{
            color: "#E09A34",
          }
        if (this.kultur5 == 2)
          return{
            color: "#E87735",
          }
        if (this.kultur5 == 1)
          return{
            color: "#F44336",
          }

      },
      warning6:function(){
        if(this.kultur6 == 5){
          return{
            color: "#62aa6c",
            animation: "anim .3s ease-in 1 alternate"
          }
        }
        if (this.kultur6 == 4)
          return{
            color: "#A1A250",
          }
        if (this.kultur6 == 3)
          return{
            color: "#E09A34",
          }
        if (this.kultur6 == 2)
          return{
            color: "#E87735",
          }
        if (this.kultur6 == 1)
          return{
            color: "#F44336",
          }

      },
      warning7:function(){
        if(this.kultur7 == 5){
          return{
            color: "#62aa6c",
            animation: "anim .3s ease-in 1 alternate"
          }
        }
        if (this.kultur7 == 4)
          return{
            color: "#A1A250",
          }
        if (this.kultur7 == 3)
          return{
            color: "#E09A34",
          }
        if (this.kultur7 == 2)
          return{
            color: "#E87735",
          }
        if (this.kultur7 == 1)
          return{
            color: "#F44336",
          }
      },
      warning8:function(){
        if(this.kultur8 == 5){
          return{
            color: "#62aa6c",
            animation: "anim .3s ease-in 1 alternate"
          }
        }
        if (this.kultur8 == 4)
          return{
            color: "#A1A250",
          }
        if (this.kultur8 == 3)
          return{
            color: "#E09A34",
          }
        if (this.kultur8 == 2)
          return{
            color: "#E87735",
          }
        if (this.kultur8 == 1)
          return{
            color: "#F44336",
          }

      },

      warning9:function(){
        if(this.kultur9 == 5){
          return{
            color: "#62aa6c",
            animation: "anim .3s ease-in 1 alternate"
          }
        }
        if (this.kultur9 == 4)
          return{
            color: "#A1A250",
          }
        if (this.kultur9 == 3)
          return{
            color: "#E09A34",
          }
        if (this.kultur9 == 2)
          return{
            color: "#E87735",
          }
        if (this.kultur9 == 1)
          return{
            color: "#F44336",
          }

      },
      warning10:function(){
        if(this.kultur10 == 5){
          return{
            color: "#62aa6c",
            animation: "anim .3s ease-in 1 alternate"
          }
        }
        if (this.kultur10 == 4)
          return{
            color: "#A1A250",
          }
        if (this.kultur10 == 3)
          return{
            color: "#E09A34",
          }
        if (this.kultur10 == 2)
          return{
            color: "#E87735",
          }
        if (this.kultur10 == 1)
          return{
            color: "#F44336",
          }

      },



      evaluateForm(){
        if (this.kultur==null) {
          this.kultur='3' 
        } 
        if (this.kultur2==null) {
          this.kultur2='3'
        } 
        if (this.kultur3==null) {
          this.kultur3='3'
        } 
        if (this.kultur4==null) {
          this.kultur4='3'
        } 
        if (this.kultur5==null) {
          this.kultur5='3'
        } 
        if (this.kultur6==null) {
          this.kultur6='3'
        }
        if (this.kultur7==null) {
          this.kultur7='3'
        }
        if (this.kultur8==null) {
          this.kultur8='3'
        }
        if (this.kultur9==null) {
          this.kultur9='3'
        }
        if (this.kultur10==null) {
          this.kultur10='3'
        }
        this.$emit('update:KulturValue', this.kultur)
        this.$emit('update:KulturValue2', this.kultur2)
        this.$emit('update:KulturValue3', this.kultur3)
        this.$emit('update:KulturValue4', this.kultur4)
        this.$emit('update:KulturValue5', this.kultur5)
        this.$emit('update:KulturValue6', this.kultur6)
        this.$emit('update:KulturValue7', this.kultur7)
        this.$emit('update:KulturValue8', this.kultur8)
        this.$emit('update:KulturValue9', this.kultur9)
        this.$emit('update:KulturValue10', this.kultur11)
        this.$emit('saved')
      }
    }
  };
</script>

<style>

body{
  margin: 0;
  padding: 0;
  background-color: #fff;
}
.container2{
  position: relative;
  height: 50 px;
  width: 600px;
  margin: 50px auto;
}
.question{
  position: relative;
  width: 600px;
  margin: 10px auto;
  padding: 10px 10px;
}

.slider{
  position: relative;
  width: 600px;
  margin: 10px auto;
  padding: 10px 10px;
}

.container2 .mySlider {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  width: 400px;
  height: 25px;
  background-color: #d3d3d3;
  border-radius: 20px;
  outline:none;
  opacity: 0.7;
  transition: opacity .2s ease-in;
  -webkit-transition: opacity .2s ease-in;

}

.container2 .mySlider:hover{
  opacity: 1;
}

.container2 .mySlider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  height: 40px;
  width: 40px;
  border-radius: 50%;
  background-color: #d3d3d3;
  cursor: pointer;
  -webkit-transition: all .3s ease-in;
  transition: all .3s ease-in;
  border: 2px solid #d3d3d3;

}

.container2 .mySlider::moz-slider-thumb {
  -moz-appearance: none;
  appearance: none;
  height: 40px;
  width: 40px;
  border-radius: 50%;
  background-color: #d3d3d3;
  cursor: pointer;
  -webkit-transition: all .3s ease-in;
  transition: all .3s ease-in;
  border: 2px solid #d3d3d3;

}

.container2 .mySlider::-webkit-slider-thumb:hover {
  box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.5)
}
.container2 .rangeValue {
  position: absolute;
  height: 40px;
  width: 60px;
  right: -20px;
  top: 50%;
  transform: translate(-50%, -50%);
  border: 1px solid #fff;
  color: #fff;
  font-weight: 600;
  font-family: 'Karla', Arial, Helvetica, sans-serif;
  text-align: center;
  line-height: 38px;
  font-size: 22px;
}

.container2 .rangeValue::before {
  position: absolute;
  content: "";
  height: 10px;
  width: 10px;
  background-color: #2f3640;
  top: 14px;
  left: -6px;
  border-top: 1px solid transparent;
  border-bottom: 1px solid #fff;
  border-left: 1px solid #fff;
  border-right: 1px solid transparent;
  transform: rotate(45deg);
}

.container3 {
  height: 40px;
  width: 150px;
  margin: 20px auto;
  justify-content: center;
}

.button_save {
  font-size: 15px;
  height: 40px;
  width: 130px;
  background-color: #0A2342;
  margin: 0px 10px;
  border-color: #00FFFF;
  color:aliceblue;
  justify-content: center;
  font-family: 'Poppins', 'Arial Black', Gadget, sans;

}

@keyframes anim {
  0%{
    right: -20px;
  }
  25%{
    right: -10px
  }
  50%{
    right: -30px
  }
  70%{
    right: -10px
  }
  100%{
    right: -20px

  }
}



</style>